import { ASSET_DESKTOP, ASSET_MOBILE } from '../elements/assets'
import { BUTTON, BUTTON_SETTINGS } from '../elements/link'

export const HERO_ASSESSMENT = `
...on heroAssessment_Entry {
  id
  typeHandle

  ${ ASSET_DESKTOP }
  ${ ASSET_MOBILE }

  heading: headingAdvanced {
    html
  }
  description

  results
  time
  format
  ${ BUTTON }
  ${ BUTTON_SETTINGS }
}
`